<template>
  <el-dialog custom-class="prefecture-select-container dialog-size-middle"
             :title="'都道府県を選択'"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div id="pref-list">
      <form-item-container v-for="area in areas" :key="area.areaCode">
         <span slot="form-item-label">
             <el-checkbox v-if="multipleSelect" :indeterminate="isIndeterminate[area.areaCode]"
                          v-model="checkAll[area.areaCode]" @change="handleCheckAllChange($event, area.areaCode)">{{area.areaName}}</el-checkbox>
             <template v-else>{{ area.areaName }}</template>
         </span>
        <field-container slot="default">
          <el-checkbox-group v-model="selectedPrefectureIds[area.areaCode]"
                             @change="handleCheckedPrefecturesChange($event, area.areaCode)">
            <el-checkbox v-for="pref in area.prefs" :label="pref.prefId" :key="pref.prefId">{{pref.prefName}}
            </el-checkbox>
          </el-checkbox-group>
        </field-container>
      </form-item-container>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible=false">キャンセル</el-button>
        <el-button type="primary" :disabled="!multipleSelect && getFlattenPrefectureIds().length > 1"
                   @click="onSelectPrefecture">OK</el-button>
    </span>
  </el-dialog>
</template>

<script lang="js">
import CommonUtil from '../../../utils/common'
import WebApiClient from '../../../api/web'
import MessageBox from '../../../utils/message-box'

export default {
  name: 'PrefectureSelectDialogCmp',
  components: {},
  props: {
    currentPrefectures: Array,
    multipleSelect: true
  },
  data () {
    return {
      areas: [],
      visible: false,
      selectedPrefectureIds: {},
      isIndeterminate: {},
      checkAll: {}
    }
  },
  mounted () {
    WebApiClient.getPrefectures(this).then(response => {
      this.areas = response.data.result.areas
      this.areas.forEach(area => {
        this.setCurrentUsage(area)
      })
      this.visible = true
    })
  },
  methods: {
    setCurrentUsage (area) {
      const areaCode = area.areaCode
      this.selectedPrefectureIds[areaCode] = []
      this.isIndeterminate[areaCode] = false
      this.checkAll[areaCode] = false

      if (CommonUtil.isNotEmpty(this.currentPrefectures)) {
        this.currentPrefectures.forEach(currentPref => {
          area.prefs.forEach(areaPref => {
            if (currentPref.prefId === areaPref.prefId) {
              this.selectedPrefectureIds[areaCode].push(currentPref.prefId)
            }
            this.updateIndeterminateStatus(areaCode)
          })
        })
      }
    },
    onSelectPrefecture () {
      const prefectureIds = this.getFlattenPrefectureIds()
      const prefectures = this.getPrefectureInfoByIds(prefectureIds)

      this.$emit('select', prefectures, this.multipleSelect)
      this.visible = false
    },
    getFlattenPrefectureIds () {
      let ids = []
      Object.keys(this.selectedPrefectureIds).forEach(key => {
        ids = ids.concat(this.selectedPrefectureIds[key])
      })
      return ids
    },
    getPrefectureInfoByIds (prefectureIds) {
      const allPrefectures = this.areas.map(area => area.prefs).reduce((acc, pref) => acc.concat(pref))

      let prefectures = []
      prefectureIds.forEach(id => {
        const prefName = allPrefectures.filter(pref => pref.prefId === id)[0].prefName
        prefectures.push({
          prefId: id,
          prefName: prefName
        })
      })
      return prefectures
    },
    handleCheckAllChange (val, areaCode) {
      if (val === true) {
        const targetArea = this.areas.filter(area => area.areaCode === areaCode)[0]
        this.selectedPrefectureIds[areaCode] = targetArea.prefs.map(pref => pref.prefId)
      } else {
        this.selectedPrefectureIds[areaCode] = []
      }
      this.isIndeterminate[areaCode] = false
      this.$forceUpdate()
    },
    handleCheckedPrefecturesChange (value, areaCode) {
      this.updateIndeterminateStatus(areaCode)
      this.$forceUpdate()

      if (this.multipleSelect === false && this.getFlattenPrefectureIds().length > 1) {
        const message = '選択出来る都道府県は1つまでです。'
        MessageBox.alert(this, message, { dangerouslyUseHTMLString: true }).then(() => {
          this.selectedPrefectureIds[areaCode] = value
          this.updateIndeterminateStatus(areaCode)
          this.$forceUpdate()
        })
      }
    },
    updateIndeterminateStatus (areaCode) {
      const checkedCount = this.selectedPrefectureIds[areaCode].length
      const targetArea = this.areas.filter(area => area.areaCode === areaCode)[0]

      this.checkAll[areaCode] = checkedCount === targetArea.prefs.length
      this.isIndeterminate[areaCode] = checkedCount > 0 && checkedCount < targetArea.prefs.length
    }
  }
}

</script>

<style scoped>
  #pref-list {
    max-height: 480px;
    overflow-y: scroll;
  }

  #pref-list >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fff;
    border-color: #2456d4;
  }

  #pref-list >>> .form-item-title .el-checkbox__label {
    color: #fff;
    font-weight: 700;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/data-collect/dialogs/prefecture-select.vue